import { IconApplicants } from '@components/icons/applicants';
import { IconEmail } from '@components/icons/email';
import { IconFile } from '@components/icons/file';
import { IconMessages } from '@components/icons/messages';
import { IconPhone } from '@components/icons/phone';
import { IconTextLong } from '@components/icons/text-long';
import { FilterConfigField } from '@components/table';
import { FilterData } from '@components/table/filters';

import { useStore } from 'models/Provider';

const personalFieldToExternalQuery = (filter: FilterData) => {
  const field = String(filter.field);
  const value = String(filter.value);

  switch (filter.comparer) {
    case 'is':
      return { [`${field}__is`]: value.toLowerCase().trim() };
    case 'starts':
      return { [`${field}__starts_with`]: value.toLowerCase().trimStart() };
    case 'not_is':
      return { [`${field}__is_not`]: value.toLowerCase().trim() };
    case 'contains':
      return { [`${field}__wildcard`]: value.toLowerCase().trimStart() };
    case 'not_contains':
      return { [`${field}__not_contain`]: value.toLowerCase().trimStart() };
    default:
      return {};
  }
};

export const usePersonalDetailsFilter = (): FilterConfigField => {
  const { t } = useStore();

  return {
    id: 'personal',
    label: t('applicants.filters.personal.title'),
    icon: <IconApplicants />,
    type: 'category',
    fields: [
      {
        id: 'name',
        label: t('applicants.filters.personal.name'),
        type: 'text',
        icon: <IconApplicants />,
        toExternalQuery: personalFieldToExternalQuery,
        allowedComparers: ['is', 'not_is', 'starts'],
      },
      {
        id: 'email',
        label: t('applicants.filters.personal.email'),
        type: 'email',
        icon: <IconEmail />,
        toExternalQuery: personalFieldToExternalQuery,
        allowedComparers: ['is', 'not_is', 'contains', 'not_contains'],
      },
      {
        id: 'phone',
        label: t('applicants.filters.personal.phone'),
        type: 'phone_number',
        icon: <IconPhone />,
        toExternalQuery: personalFieldToExternalQuery,
        allowedComparers: ['is', 'not_is', 'contains', 'not_contains'],
      },
      {
        id: 'cv',
        label: t('applicants.filters.personal.cv'),
        type: 'text',
        icon: <IconFile />,
        allowedComparers: ['contains', 'not_contains'],
        toExternalQuery: personalFieldToExternalQuery,
      },
      {
        id: 'cover_letter',
        label: t('applicants.filters.personal.cover_letter'),
        type: 'text',
        icon: <IconFile />,
        allowedComparers: ['contains', 'not_contains'],
        toExternalQuery: personalFieldToExternalQuery,
      },
      {
        id: 'notes',
        label: t('applicants.filters.personal.notes'),
        type: 'text',
        icon: <IconTextLong />,
        allowedComparers: ['contains', 'not_contains'],
        toExternalQuery: personalFieldToExternalQuery,
      },
      {
        id: 'messages',
        label: t('applicants.filters.personal.messages'),
        type: 'text',
        icon: <IconMessages />,
        allowedComparers: ['contains', 'not_contains'],
        toExternalQuery: personalFieldToExternalQuery,
      },
    ],
  };
};
